<template>
  <vs-popup class="add-user-types"
            id="popup"
            :title="isCreateMode ? 'ADD NIMBLE USER TYPE' : 'UPDATE NIMBLE USER TYPE'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-user-type-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-user-type-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const CustomerUserTypeRepository = RepositoryFactory.get('customer_user_type');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        description: '',
        is_default: false
      },
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewCustomerUserTypePopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchUserType()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async fetchUserType() {
        await this.$vs.loading({
          container: '#create-user-type-popup',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerUserTypeRepository.getUserType(this.id)).data
          this.form = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-user-type-popup > .con-vs-loading')
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-user-type-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await CustomerUserTypeRepository.createUserType(this.form);
            this.showSuccessMessage('User role added!');
          } else {
            await CustomerUserTypeRepository.updateUserType(this.id, this.form);
            this.showSuccessMessage('User role updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-user-type-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-user-type-popup > .con-vs-loading')
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-user-types >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
